import { useEffect, useState } from "react";
import { apiRequest } from "../utils/api";
import { apiRequestFile } from "../utils/api";
import { useParams, useNavigate } from "react-router-dom";
import "../styles/InventoryDiff.css";

const InventoryDiff = () => {
  const { sessionId } = useParams();
  const navigate = useNavigate();

  const [items, setItems] = useState([]);
  const [onlyDiff, setOnlyDiff] = useState(false);
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [importResult, setImportResult] = useState(null);

  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const pageSize = 50;

  const errorJans = importResult?.not_in_master || [];
  const totalPages = Math.max(1, Math.ceil(totalCount / pageSize));

  const fetchDiff = async (targetPage = page) => {
    try {
      const data = await apiRequest(
        `inventory/sessions/${sessionId}/diff/?only_diff=${onlyDiff}&page=${targetPage}&page_size=${pageSize}`,
        "GET"
      );

      setItems(data.results ?? []);
      setTotalCount(data.count ?? 0);
      setPage(targetPage);
    } catch (error) {
      console.error("差異取得失敗", error);
    }
  };

  useEffect(() => {
    fetchDiff(1);
  }, [sessionId, onlyDiff]);

  const handleBack = () => {
    navigate(-1);
  };

  const handleImport = async () => {
    if (!file) {
      alert("CSVファイルを選択してください");
      return;
    }

    if (!window.confirm("現在のカウントに加算されます。実行しますか？")) {
      return;
    }

    setLoading(true);

    try {
      const data = await apiRequestFile(
        `inventory/sessions/${sessionId}/import-csv/`,
        "POST",
        file
      );

      setImportResult(data);
      fetchDiff(1);
    } catch (err) {
      console.error("インポート失敗", err);
    } finally {
      setLoading(false);
    }
  };

  const downloadCsv = (jans) => {
    const csvContent = "\uFEFF" + ["JAN"].concat(jans).join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = "not_in_master_jans.csv";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    URL.revokeObjectURL(url);
  };

  return (
    <div className="inventoryDiffbasebox">
      <div className="inventoryDiffButtonbox">
        <button className="inventoryDiff-backButton" onClick={handleBack}>
          戻る
        </button>

        <button
          className="inventoryDiff-onlyButton"
          onClick={() => {
            setPage(1);
            setOnlyDiff((prev) => !prev);
          }}
        >
          {onlyDiff ? "すべて表示" : "差異のみ表示"}
        </button>

        <div>
          <input
            className="inventoryDiff-input"
            type="file"
            accept=".csv"
            onChange={(e) => setFile(e.target.files[0])}
          />

          <button
            className="inventoryDiff-csvButton"
            onClick={handleImport}
            disabled={loading}
          >
            {loading ? "インポート中..." : "CSVインポート"}
          </button>

          {importResult && (
            <div style={{ margin: "5px 0px 0px 10px" }}>
              <p>
                更新件数: {importResult.updated_count}
                {"　　"}
                マスタ未登録JAN: {importResult.not_in_master_count}
              </p>

              {errorJans.length > 0 && (
                <>
                  {errorJans.length <= 10 ? (
                    <div style={{ color: "red" }}>
                      <strong>マスタ未登録JAN:</strong>
                      <ul>
                        {errorJans.map((jan, i) => (
                          <li key={i}>{jan}</li>
                        ))}
                      </ul>
                    </div>
                  ) : (
                    <button
                      onClick={() => downloadCsv(errorJans)}
                      style={{ marginTop: "5px" }}
                    >
                      未登録JANをCSVダウンロード（{errorJans.length}件）
                    </button>
                  )}
                </>
              )}
            </div>
          )}
        </div>
      </div>

      <div className="inventoryDiffbox">
        <h2>棚卸差異確認</h2>

        <div style={{ marginBottom: "8px" }}>
          <button disabled={page <= 1} onClick={() => fetchDiff(page - 1)}>
            前へ
          </button>
          <span style={{ margin: "0 12px" }}>
            {page} / {totalPages} ページ（全 {totalCount} 件）
          </span>
          <button
            disabled={page >= totalPages}
            onClick={() => fetchDiff(page + 1)}
          >
            次へ
          </button>
        </div>

        <table border="1" cellPadding="8" style={{ width: "100%" }}>
          <thead>
            <tr>
              <th>画像</th>
              <th>JAN</th>
              <th>タイトル</th>
              <th>本来個数</th>
              <th>カウント個数</th>
              <th>差異</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item) => (
              <tr key={item.id}>
                <td>
                  <img src={`/media/product_images/${item.sku}.jpg?`} alt="" />
                </td>
                <td>{item.jan}</td>
                <td>{item.title}</td>
                <td>{item.base_stock}</td>
                <td>{item.counted_stock}</td>
                <td
                  style={{
                    color: item.difference !== 0 ? "red" : "black",
                    fontWeight: "bold",
                  }}
                >
                  {item.difference}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default InventoryDiff;